export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/revolut_pay.e3d81553.svg","height":8,"width":20,"blurWidth":0,"blurHeight":0};